import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { addAction } from '../../actions/action';
import DatePicker from 'react-date-picker';
import { makeStyles } from '@material-ui/core';
import moment from 'moment';

const AddAction = ({ addAction, contactID }) => {
  const useStyles = makeStyles(theme => ({
    newActionBody: {
      padding: '5px',
      background: '#F2F4F4'
    }
  }));

  const classes = useStyles();
  const [timeValue, onChange] = useState(new Date());

  const [formData, setFormData] = useState({
    nameNew: '',
    timeNew: ''
  });

  const { nameNew } = formData;

  const onChangeInput = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    let difference = moment().diff(moment(timeValue), 'seconds');
    if (difference < 0) {
      formData.timeNew = timeValue;
      addAction(formData, contactID);
    }
  };

  return (
    <Fragment>
      <div className={classes.newActionBody}>
        <h3>New Action</h3>{' '}
        <div>
          <DatePicker required onChange={onChange} value={timeValue} />
        </div>
        <form className='na-form' onSubmit={e => onSubmit(e)}>
          <div className='form-group'>
            <input
              type='text'
              placeholder='Action'
              name='nameNew'
              value={nameNew}
              onChange={e => onChangeInput(e)}
              required
            />
          </div>
          <input type='submit' className='btn btn-firm' value='Save' />
        </form>
      </div>
    </Fragment>
  );
};

AddAction.propTypes = {
  contactID: PropTypes.object.isRequired,
  addAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { addAction })(AddAction);



// WEBPACK FOOTER //
// ./src/components/actionStream/AddAction.js